import styled from '@emotion/styled';

import { Button as ButtonBase } from '~/src/components/buttons';
import { darkGrey, fontWeight } from '~/src/styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const H2 = styled.h2`
  font-size: 24px;
  font-weight: ${fontWeight.semiBold};
  line-height: 29px;
  letter-spacing: 0.03em;
  text-align: center;
  color: ${darkGrey};
  text-transform: uppercase;
`;

export const Button = styled(ButtonBase)`
  height: 50px !important;
  border-radius: 30px !important;
  letter-spacing: 0.1em !important;
  color: #ffffff;
  font-size: 14px !important;
  font-weight: ${fontWeight.semiBold} !important;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
